import React from "react";
import classNames from "classnames";
import styles from "./fix-link.module.scss";
import { useLayoutType, LayoutStyleTypes, LayoutTypes } from "@/util-react/layout";

export enum FixLinkTypes {
  TYPE_SM = LayoutStyleTypes.TYPE_SM,
  TYPE_MD = LayoutStyleTypes.TYPE_MD,
  TYPE_MD_BLUE = "md-blue",
}

export type FixLinkType = FixLinkTypes.TYPE_SM | FixLinkTypes.TYPE_MD | FixLinkTypes.TYPE_MD_BLUE;

export interface FixLinkProps {
  href?: string;
  ariaLabel?: string;
  type?: FixLinkType;
  className?: string;
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  target?: string;
}

export const FixLink: React.FC<FixLinkProps> = ({ href = "", ariaLabel = "", target = "", type = LayoutStyleTypes.TYPE_SM, className, children, onClick }) => {
  const linkClass = classNames(
    styles.link,
    {
      [styles.linkMd]: type === LayoutStyleTypes.TYPE_MD,
      [styles.linkMdBlue]: type === FixLinkTypes.TYPE_MD_BLUE,
    },
    className,
  );
  const labelClass = classNames(styles.label, {
    [styles.labelMd]: type === LayoutStyleTypes.TYPE_MD,
    [styles.labelSm]: type === LayoutStyleTypes.TYPE_SM,
  });

  return (
    <a href={href} aria-label={ariaLabel} className={linkClass} onClick={onClick} target={target}>
      <span className={labelClass}>{children}</span>
    </a>
  );
};
